import Pill from '~/components/Pill';
import { formatDate } from '~/utils/datetime';
import { TEMPLATE_MAPPER } from '../constants';
import { useEmailListContext } from '../hooks/useEmailListContext';
import * as Styles from './styles';

const EmailList = () => {
  const { listIds, listData } = useEmailListContext();

  return (
    <Styles.ListContainer>
      {listIds.map(emailUuid => {
        const email = listData[emailUuid];
        if (!email) return null;

        const statusColor =
          email.status === 'sent'
            ? 'success'
            : email.status === 'failed'
              ? 'danger'
              : email.status === 'opened'
                ? 'primary'
                : 'secondary';

        return (
          <Styles.EmailCard key={emailUuid}>
            <Styles.EmailHeader>
              <Styles.RecipientName>{email.recipient_name || 'Unknown'}</Styles.RecipientName>
              <Pill variant={statusColor} size="sm">
                {email.status}
              </Pill>
            </Styles.EmailHeader>
            <Styles.EmailDetail>
              <Styles.Label>Email:</Styles.Label>
              <Styles.Value>{email.recipient_email}</Styles.Value>
            </Styles.EmailDetail>
            <Styles.EmailDetail>
              <Styles.Label>Subject:</Styles.Label>
              <Styles.Value>{email.subject}</Styles.Value>
            </Styles.EmailDetail>
            <Styles.EmailDetail>
              <Styles.Label>Template:</Styles.Label>
              <Styles.Value>{TEMPLATE_MAPPER[email.template_id] || email.template_id}</Styles.Value>
            </Styles.EmailDetail>
            <Styles.EmailDetail>
              <Styles.Label>Sent:</Styles.Label>
              <Styles.Value>{email.sent_at ? formatDate(email.sent_at) : '-'}</Styles.Value>
            </Styles.EmailDetail>
          </Styles.EmailCard>
        );
      })}
    </Styles.ListContainer>
  );
};

export default EmailList;
